var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDance10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 569,
    viewBox: "0 0 247 569",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2120_10885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.3252 501.309C142.062 501.309 180.852 481.034 195.326 448.594L201.116 494.358H247.432V316.515C247.432 240.049 199.958 202.975 129.904 202.975C56.9563 202.975 8.32422 241.787 8.32422 300.875H55.7988C55.7988 266.697 81.8516 246.421 127.589 246.421C165.8 246.421 194.168 263.221 194.168 310.723V318.833L105.01 325.784C38.4303 330.998 -0.359375 363.438 -0.359375 415.574C-0.359375 467.131 35.5352 501.309 96.3252 501.309ZM111.957 459.021C76.6409 459.021 54.6406 443.959 54.6406 413.836C54.6406 386.03 74.3254 367.493 122.378 362.859L194.747 357.066V372.127C194.747 425.422 163.484 459.021 111.957 459.021Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2120_10885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 247,
    height: 569,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDance10);
export default __webpack_public_path__ + "static/media/dance10.970442f5ad9d886bc5966ec32d974520.svg";
export { ForwardRef as ReactComponent };